import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  lucideBanknote,
  lucideChartColumn,
  lucideCreditCard,
  lucideWallet,
  lucideCalculator,
  lucideChartPie,
  lucideLandmark,
  lucideTrendingUp,
  lucideDollarSign,
  lucideReceipt,
} from '@ng-icons/lucide';
import { ThemeToggleComponent } from '../../components/ui';

/**
 * Minimal layout for login page: no sidebar, just centered content and router outlet.
 */
@Component({
  selector: 'app-login-layout',
  standalone: true,
  imports: [RouterOutlet, NgIcon, ThemeToggleComponent],
  providers: [
    provideIcons({
      lucideBanknote,
      lucideChartColumn,
      lucideCreditCard,
      lucideWallet,
      lucideCalculator,
      lucideChartPie,
      lucideLandmark,
      lucideTrendingUp,
      lucideDollarSign,
      lucideReceipt,
    }),
  ],
  templateUrl: './login-layout.component.html',
  styleUrl: './login-layout.component.scss',
})
export class LoginLayoutComponent {}
